import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import logo from '../assets/main-logo.png';
import Container from "react-bootstrap/Container";
import { SocialIcon } from 'react-social-icons';
import callanswer from "./call.svg";
import envelopeimg from "./env.svg";
import Fade from 'react-reveal/Fade';
import { Dimensions } from '../Helper/sitedimension';
import './Footer.css';

const footer = () => {
  const { width } = Dimensions.useWindowDimensions();
  const logoStyle = {
    color: "#ff5b56",
    textAlign: "left",
    position: "relative",
    top: "5px"
  };

  const pStyle = {
    color: "#303030",
    textAlign: "left",
    width: "75%",
    position: "relative",
    top: "10px"
  };

  const h6Style = {
    color: "#ff5b56",
    left: "55px",
    position: "absolute",
    fontSize: "18px",
    top: "25px",
    textDecoration: "none"
  };

  const h6Style1 = {
    color: "#ff5b56",
    left: "55px",
    fontSize: "25px",
    position: "absolute",
    top: "30px",
    textDecoration: "none"
  };

  const listStyle = {
    listStyle: "none",
    textAlign: "left",
    fontFamily: "Roboto",
    color: "#303030",
    position: "absolute",
    top: "90px",
  };

  const listyle = {
    paddingBottom: "10px",
    color: "black",
    fontSize: "15px",
    textDecoration: "none"
    
  }


  return (
    <Fragment>
      {width > 500 ? (
        <Container
          className="col-12 footer"
          style={{
            height: "450px",

            backgroundRepeat: "no-repeat",
          }}
        >
          <Row
            style={{
              position: "absolute",
              bottom: "35%"
            }}
          >
            <Col className="col-5 pl-5">
              <Link to='/'><h1 style={logoStyle}><Fade delay={300}><img src={logo} alt="logo" style={{ width: "220px", height: "50px" }} /></Fade></h1></Link>
              <br />
              <p style={pStyle}>
                <Fade delay={500}>
                Secure Blink’s AI-enabled cybersecurity products
                empower next-generation security measures. 
                Our team is consistently striving to counter 
                the cybersecurity challenges and come up with 
                the best solutions to tackle them. We are 
                working with a vision to build cutting 
                edge-products for cybersecurity using the 
                emerging technologies. 

            </Fade>
              </p>
            </Col>
            <Col className="col-2">
              <h6 style={h6Style}>Company</h6>
              <br />
              <br />
              <br />
              <ul style={listStyle}>
                <li style={listyle}><Link to="/about" style={listyle}>About Us</Link></li>
                <li style={listyle}><Link to="/services" style={listyle}>Services</Link></li>
                <li style={listyle}>Blog</li>
              </ul>
            </Col>
            <Col className="col-2">
              <h6 style={h6Style}>Support</h6>
              <br />
              <br />
              <br />
              <ul style={listStyle}>
                <li style={listyle}>Privacy Policy</li>
                <li style={listyle}>Terms of Use</li>
                <li style={listyle}>Faqs</li>
              </ul>
            </Col>
            <Col className="col-3">
              <Link to="/contactus" style={h6Style}>Contact Us</Link>
              <br />
              <br />
              <br />
              <br />
              <br />
              <ul style={{ textAlign: "left", listStyle: "none", position: "absolute", top: "90px" }}>
                <li
                  style={{
                    listStyleImage: "url()"
                  }}
                >
                  <img style={{ marginRight: "5px" }} src={callanswer} alt="X" />
                  <a href="tel:+91-9116642616" style={{ textDecoration: "none", color: "black" }}>&nbsp;+91-9116642616, 9782011886</a>
                </li>
              </ul>
              <ul style={{ textAlign: "left", listStyle: "none", position: "absolute", top: "130px" }}>
                <li>
                  <img style={{ marginRight: "5px" }} src={envelopeimg} alt="X" />
                  <a href="mailto:contact@secureblink.com" style={{ textDecoration: "none", color: "black" }}>&nbsp;contact@secureblink.com</a>
                </li>
                <br />
                <li>
                  <div className="social-footer">
                    <Fade delay={700}>
                      <div className="social-icon"><SocialIcon url="http://facebook.com/secureblink" network="facebook" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                      <div className="social-icon"><SocialIcon url="http://twitter.com/secure_blink" network="twitter" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                      <div className="social-icon"><SocialIcon url="http://linkedin.com/company/secureblink" network="linkedin" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                      <div className="social-icon"><SocialIcon url="http://instagram.com" network="instagram" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                    </Fade>
                  </div>
                </li>
              </ul>
            </Col>
          </Row>
          <Row
            className="h-20"
            style={{
              position: "absolute",
              bottom: "0",
              width: "100%"
            }}
          >
            <Col className="col-12" style={{ backgroundColor: "#000000" }}>
              <br />
              <p className="copyright" style={{ color: "#ffffff", textAlign: "center" }}>
                &copy; Secure Blink 2019. ALL RIGHT RESERVED
          </p>
            </Col>
          </Row>
        </Container>) : (
          <Fragment>
            <Row style={{ height: "300px", width: "100%", overflowX: "hidden" }}>
              <Col style={{ paddingLeft: "15px", width: "100%" }}>
                <Link to="/contactus" style={h6Style1}>Contact Us</Link>
                <ul style={{ textAlign: "left", listStyle: "none", position: "absolute", top: "90px" }}>
                  <li
                    style={{
                      listStyleImage: "url()"
                    }}
                  >
                    <img style={{ marginRight: "5px" }} src={callanswer} alt="X" />
                    <a href="tel:+91-9116642616, 9782011886" style={{ textDecoration: "none", color: "black" }}>&nbsp;+91-9116642616, 9782011886</a>
                  </li>
                </ul>
                <ul style={{ textAlign: "left", listStyle: "none", position: "absolute", top: "130px" }}>
                  <li>
                    <img style={{ marginRight: "5px" }} src={envelopeimg} alt="X" />
                    <a href="mailto:contact@secureblink.com" style={{ textDecoration: "none", color: "black" }}>&nbsp;contact@secureblink.com</a>
                  </li>
                  <br />
                  <li>
                    <div className="social-footer1">
                      <Fade delay={700}>
                        <div className="social-icon1"><SocialIcon url="http://facebook.com/secureblink" network="facebook" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                        <div className="social-icon1"><SocialIcon url="http://twitter.com/secure_blink" network="twitter" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                        <div className="social-icon1"><SocialIcon url="http://instagram.com" network="instagram" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                        <div className="social-icon1"><SocialIcon url="http://linkedin.com/company/secure-blink" network="linkedin" fgColor="white" bgColor="#ff5b56" style={{ height: 40, width: 40 }} /></div>
                      </Fade>
                    </div>
                  </li>
                </ul>
              </Col>
            </Row>
            <Col style={{ backgroundColor: "#000000" }}>
              <br />
              <p style={{ backgroundColor: "black", color: "#ffffff", textAlign: "center" }}>
                &copy; Secure Blink 2019. ALL RIGHT RESERVED
              </p>
              <br />
            </Col>
          </Fragment>)}
    </Fragment>
  );
};

export default footer;
